/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * SoraFlo - Shopify Automation Platform API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AuthResponse,
  CreateFlowRequest,
  CreatePoDraftOrder200,
  CreatePoDraftOrderBody,
  CreateStoreRequest,
  DashboardStats,
  DeletePoMapping200,
  DeletePoMappingParams,
  ErrorResponse,
  ExtractPurchaseOrder200,
  ExtractPurchaseOrderParams,
  Flow,
  GetFlowLogsParams,
  HealthStatus,
  ListLogsParams,
  ListPoMappings200Item,
  ListPoMappingsParams,
  LoginRequest,
  RegisterRequest,
  RunLog,
  SavePoMapping200,
  SavePoMappingBody,
  SearchPoCustomers200Item,
  SearchPoCustomersParams,
  SearchPoVariants200Item,
  SearchPoVariantsParams,
  Store,
  StoreTestResult,
  UpdateFlowRequest,
  UpdatePoMapping200,
  UpdatePoMappingBody,
  UpdateStoreRequest,
  User,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Extract a PDF and suggest customer and variant matches
 */
export const getExtractPurchaseOrderUrl = (
  params: ExtractPurchaseOrderParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/po-draft-import/extract?${stringifiedParams}`
    : `/api/po-draft-import/extract`;
};

export const extractPurchaseOrder = async (
  extractPurchaseOrderBody: Blob,
  params: ExtractPurchaseOrderParams,
  options?: RequestInit,
): Promise<ExtractPurchaseOrder200> => {
  return customFetch<ExtractPurchaseOrder200>(
    getExtractPurchaseOrderUrl(params),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/pdf", ...options?.headers },
      body: JSON.stringify(extractPurchaseOrderBody),
    },
  );
};

export const getExtractPurchaseOrderMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractPurchaseOrder>>,
    TError,
    { data: BodyType<Blob>; params: ExtractPurchaseOrderParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractPurchaseOrder>>,
  TError,
  { data: BodyType<Blob>; params: ExtractPurchaseOrderParams },
  TContext
> => {
  const mutationKey = ["extractPurchaseOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractPurchaseOrder>>,
    { data: BodyType<Blob>; params: ExtractPurchaseOrderParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return extractPurchaseOrder(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtractPurchaseOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof extractPurchaseOrder>>
>;
export type ExtractPurchaseOrderMutationBody = BodyType<Blob>;
export type ExtractPurchaseOrderMutationError = ErrorType<void>;

/**
 * @summary Extract a PDF and suggest customer and variant matches
 */
export const useExtractPurchaseOrder = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractPurchaseOrder>>,
    TError,
    { data: BodyType<Blob>; params: ExtractPurchaseOrderParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof extractPurchaseOrder>>,
  TError,
  { data: BodyType<Blob>; params: ExtractPurchaseOrderParams },
  TContext
> => {
  return useMutation(getExtractPurchaseOrderMutationOptions(options));
};

export const getSearchPoVariantsUrl = (params: SearchPoVariantsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/po-draft-import/variants?${stringifiedParams}`
    : `/api/po-draft-import/variants`;
};

export const searchPoVariants = async (
  params: SearchPoVariantsParams,
  options?: RequestInit,
): Promise<SearchPoVariants200Item[]> => {
  return customFetch<SearchPoVariants200Item[]>(
    getSearchPoVariantsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getSearchPoVariantsQueryKey = (
  params?: SearchPoVariantsParams,
) => {
  return [
    `/api/po-draft-import/variants`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchPoVariantsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchPoVariants>>,
  TError = ErrorType<unknown>,
>(
  params: SearchPoVariantsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchPoVariants>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchPoVariantsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchPoVariants>>
  > = ({ signal }) => searchPoVariants(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchPoVariants>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchPoVariantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchPoVariants>>
>;
export type SearchPoVariantsQueryError = ErrorType<unknown>;

export function useSearchPoVariants<
  TData = Awaited<ReturnType<typeof searchPoVariants>>,
  TError = ErrorType<unknown>,
>(
  params: SearchPoVariantsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchPoVariants>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchPoVariantsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSearchPoCustomersUrl = (params: SearchPoCustomersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/po-draft-import/customers?${stringifiedParams}`
    : `/api/po-draft-import/customers`;
};

export const searchPoCustomers = async (
  params: SearchPoCustomersParams,
  options?: RequestInit,
): Promise<SearchPoCustomers200Item[]> => {
  return customFetch<SearchPoCustomers200Item[]>(
    getSearchPoCustomersUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getSearchPoCustomersQueryKey = (
  params?: SearchPoCustomersParams,
) => {
  return [
    `/api/po-draft-import/customers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchPoCustomersQueryOptions = <
  TData = Awaited<ReturnType<typeof searchPoCustomers>>,
  TError = ErrorType<unknown>,
>(
  params: SearchPoCustomersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchPoCustomers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchPoCustomersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchPoCustomers>>
  > = ({ signal }) => searchPoCustomers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchPoCustomers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchPoCustomersQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchPoCustomers>>
>;
export type SearchPoCustomersQueryError = ErrorType<unknown>;

export function useSearchPoCustomers<
  TData = Awaited<ReturnType<typeof searchPoCustomers>>,
  TError = ErrorType<unknown>,
>(
  params: SearchPoCustomersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchPoCustomers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchPoCustomersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListPoMappingsUrl = (params: ListPoMappingsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/po-draft-import/mappings?${stringifiedParams}`
    : `/api/po-draft-import/mappings`;
};

export const listPoMappings = async (
  params: ListPoMappingsParams,
  options?: RequestInit,
): Promise<ListPoMappings200Item[]> => {
  return customFetch<ListPoMappings200Item[]>(getListPoMappingsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListPoMappingsQueryKey = (params?: ListPoMappingsParams) => {
  return [
    `/api/po-draft-import/mappings`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListPoMappingsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPoMappings>>,
  TError = ErrorType<unknown>,
>(
  params: ListPoMappingsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPoMappings>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPoMappingsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPoMappings>>> = ({
    signal,
  }) => listPoMappings(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPoMappings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPoMappingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPoMappings>>
>;
export type ListPoMappingsQueryError = ErrorType<unknown>;

export function useListPoMappings<
  TData = Awaited<ReturnType<typeof listPoMappings>>,
  TError = ErrorType<unknown>,
>(
  params: ListPoMappingsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPoMappings>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPoMappingsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSavePoMappingUrl = () => {
  return `/api/po-draft-import/mappings`;
};

export const savePoMapping = async (
  savePoMappingBody: SavePoMappingBody,
  options?: RequestInit,
): Promise<SavePoMapping200> => {
  return customFetch<SavePoMapping200>(getSavePoMappingUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(savePoMappingBody),
  });
};

export const getSavePoMappingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof savePoMapping>>,
    TError,
    { data: BodyType<SavePoMappingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof savePoMapping>>,
  TError,
  { data: BodyType<SavePoMappingBody> },
  TContext
> => {
  const mutationKey = ["savePoMapping"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof savePoMapping>>,
    { data: BodyType<SavePoMappingBody> }
  > = (props) => {
    const { data } = props ?? {};

    return savePoMapping(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SavePoMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof savePoMapping>>
>;
export type SavePoMappingMutationBody = BodyType<SavePoMappingBody>;
export type SavePoMappingMutationError = ErrorType<unknown>;

export const useSavePoMapping = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof savePoMapping>>,
    TError,
    { data: BodyType<SavePoMappingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof savePoMapping>>,
  TError,
  { data: BodyType<SavePoMappingBody> },
  TContext
> => {
  return useMutation(getSavePoMappingMutationOptions(options));
};

export const getUpdatePoMappingUrl = (id: string) => {
  return `/api/po-draft-import/mappings/${id}`;
};

export const updatePoMapping = async (
  id: string,
  updatePoMappingBody: UpdatePoMappingBody,
  options?: RequestInit,
): Promise<UpdatePoMapping200> => {
  return customFetch<UpdatePoMapping200>(getUpdatePoMappingUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePoMappingBody),
  });
};

export const getUpdatePoMappingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePoMapping>>,
    TError,
    { id: string; data: BodyType<UpdatePoMappingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePoMapping>>,
  TError,
  { id: string; data: BodyType<UpdatePoMappingBody> },
  TContext
> => {
  const mutationKey = ["updatePoMapping"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePoMapping>>,
    { id: string; data: BodyType<UpdatePoMappingBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePoMapping(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePoMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePoMapping>>
>;
export type UpdatePoMappingMutationBody = BodyType<UpdatePoMappingBody>;
export type UpdatePoMappingMutationError = ErrorType<unknown>;

export const useUpdatePoMapping = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePoMapping>>,
    TError,
    { id: string; data: BodyType<UpdatePoMappingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePoMapping>>,
  TError,
  { id: string; data: BodyType<UpdatePoMappingBody> },
  TContext
> => {
  return useMutation(getUpdatePoMappingMutationOptions(options));
};

export const getDeletePoMappingUrl = (
  id: string,
  params: DeletePoMappingParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/po-draft-import/mappings/${id}?${stringifiedParams}`
    : `/api/po-draft-import/mappings/${id}`;
};

export const deletePoMapping = async (
  id: string,
  params: DeletePoMappingParams,
  options?: RequestInit,
): Promise<DeletePoMapping200> => {
  return customFetch<DeletePoMapping200>(getDeletePoMappingUrl(id, params), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePoMappingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePoMapping>>,
    TError,
    { id: string; params: DeletePoMappingParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePoMapping>>,
  TError,
  { id: string; params: DeletePoMappingParams },
  TContext
> => {
  const mutationKey = ["deletePoMapping"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePoMapping>>,
    { id: string; params: DeletePoMappingParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return deletePoMapping(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePoMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePoMapping>>
>;

export type DeletePoMappingMutationError = ErrorType<unknown>;

export const useDeletePoMapping = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePoMapping>>,
    TError,
    { id: string; params: DeletePoMappingParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePoMapping>>,
  TError,
  { id: string; params: DeletePoMappingParams },
  TContext
> => {
  return useMutation(getDeletePoMappingMutationOptions(options));
};

/**
 * @summary Create a reviewed Shopify draft order using current store prices
 */
export const getCreatePoDraftOrderUrl = () => {
  return `/api/po-draft-import/create`;
};

export const createPoDraftOrder = async (
  createPoDraftOrderBody: CreatePoDraftOrderBody,
  options?: RequestInit,
): Promise<CreatePoDraftOrder200> => {
  return customFetch<CreatePoDraftOrder200>(getCreatePoDraftOrderUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPoDraftOrderBody),
  });
};

export const getCreatePoDraftOrderMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPoDraftOrder>>,
    TError,
    { data: BodyType<CreatePoDraftOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPoDraftOrder>>,
  TError,
  { data: BodyType<CreatePoDraftOrderBody> },
  TContext
> => {
  const mutationKey = ["createPoDraftOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPoDraftOrder>>,
    { data: BodyType<CreatePoDraftOrderBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createPoDraftOrder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePoDraftOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPoDraftOrder>>
>;
export type CreatePoDraftOrderMutationBody = BodyType<CreatePoDraftOrderBody>;
export type CreatePoDraftOrderMutationError = ErrorType<void>;

/**
 * @summary Create a reviewed Shopify draft order using current store prices
 */
export const useCreatePoDraftOrder = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPoDraftOrder>>,
    TError,
    { data: BodyType<CreatePoDraftOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPoDraftOrder>>,
  TError,
  { data: BodyType<CreatePoDraftOrderBody> },
  TContext
> => {
  return useMutation(getCreatePoDraftOrderMutationOptions(options));
};

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register a new user
 */
export const getRegisterUrl = () => {
  return `/api/auth/register`;
};

export const register = async (
  registerRequest: RegisterRequest,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getRegisterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(registerRequest),
  });
};

export const getRegisterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterRequest> },
  TContext
> => {
  const mutationKey = ["register"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof register>>,
    { data: BodyType<RegisterRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return register(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof register>>
>;
export type RegisterMutationBody = BodyType<RegisterRequest>;
export type RegisterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Register a new user
 */
export const useRegister = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterRequest> },
  TContext
> => {
  return useMutation(getRegisterMutationOptions(options));
};

/**
 * @summary Login
 */
export const getLoginUrl = () => {
  return `/api/auth/login`;
};

export const login = async (
  loginRequest: LoginRequest,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginRequest),
  });
};

export const getLoginMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: BodyType<LoginRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = BodyType<LoginRequest>;
export type LoginMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Login
 */
export const useLogin = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  return useMutation(getLoginMutationOptions(options));
};

/**
 * @summary Get current user
 */
export const getGetMeUrl = () => {
  return `/api/auth/me`;
};

export const getMe = async (options?: RequestInit): Promise<User> => {
  return customFetch<User>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current user
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all connected stores
 */
export const getListStoresUrl = () => {
  return `/api/stores`;
};

export const listStores = async (options?: RequestInit): Promise<Store[]> => {
  return customFetch<Store[]>(getListStoresUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListStoresQueryKey = () => {
  return [`/api/stores`] as const;
};

export const getListStoresQueryOptions = <
  TData = Awaited<ReturnType<typeof listStores>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listStores>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStoresQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStores>>> = ({
    signal,
  }) => listStores({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStores>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStoresQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStores>>
>;
export type ListStoresQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all connected stores
 */

export function useListStores<
  TData = Awaited<ReturnType<typeof listStores>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listStores>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListStoresQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add a new store connection
 */
export const getCreateStoreUrl = () => {
  return `/api/stores`;
};

export const createStore = async (
  createStoreRequest: CreateStoreRequest,
  options?: RequestInit,
): Promise<Store> => {
  return customFetch<Store>(getCreateStoreUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createStoreRequest),
  });
};

export const getCreateStoreMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStore>>,
    TError,
    { data: BodyType<CreateStoreRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStore>>,
  TError,
  { data: BodyType<CreateStoreRequest> },
  TContext
> => {
  const mutationKey = ["createStore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStore>>,
    { data: BodyType<CreateStoreRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createStore(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStore>>
>;
export type CreateStoreMutationBody = BodyType<CreateStoreRequest>;
export type CreateStoreMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Add a new store connection
 */
export const useCreateStore = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStore>>,
    TError,
    { data: BodyType<CreateStoreRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStore>>,
  TError,
  { data: BodyType<CreateStoreRequest> },
  TContext
> => {
  return useMutation(getCreateStoreMutationOptions(options));
};

/**
 * @summary Get a store by ID
 */
export const getGetStoreUrl = (id: string) => {
  return `/api/stores/${id}`;
};

export const getStore = async (
  id: string,
  options?: RequestInit,
): Promise<Store> => {
  return customFetch<Store>(getGetStoreUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetStoreQueryKey = (id: string) => {
  return [`/api/stores/${id}`] as const;
};

export const getGetStoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getStore>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStore>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStoreQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStore>>> = ({
    signal,
  }) => getStore(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetStoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStore>>
>;
export type GetStoreQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a store by ID
 */

export function useGetStore<
  TData = Awaited<ReturnType<typeof getStore>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStore>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStoreQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a store connection
 */
export const getUpdateStoreUrl = (id: string) => {
  return `/api/stores/${id}`;
};

export const updateStore = async (
  id: string,
  updateStoreRequest: UpdateStoreRequest,
  options?: RequestInit,
): Promise<Store> => {
  return customFetch<Store>(getUpdateStoreUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateStoreRequest),
  });
};

export const getUpdateStoreMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStore>>,
    TError,
    { id: string; data: BodyType<UpdateStoreRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStore>>,
  TError,
  { id: string; data: BodyType<UpdateStoreRequest> },
  TContext
> => {
  const mutationKey = ["updateStore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStore>>,
    { id: string; data: BodyType<UpdateStoreRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateStore(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStore>>
>;
export type UpdateStoreMutationBody = BodyType<UpdateStoreRequest>;
export type UpdateStoreMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update a store connection
 */
export const useUpdateStore = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStore>>,
    TError,
    { id: string; data: BodyType<UpdateStoreRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStore>>,
  TError,
  { id: string; data: BodyType<UpdateStoreRequest> },
  TContext
> => {
  return useMutation(getUpdateStoreMutationOptions(options));
};

/**
 * @summary Delete a store connection
 */
export const getDeleteStoreUrl = (id: string) => {
  return `/api/stores/${id}`;
};

export const deleteStore = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteStoreUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteStoreMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStore>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStore>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteStore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStore>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteStore(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStore>>
>;

export type DeleteStoreMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a store connection
 */
export const useDeleteStore = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStore>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteStore>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteStoreMutationOptions(options));
};

/**
 * @summary Test a store connection
 */
export const getTestStoreUrl = (id: string) => {
  return `/api/stores/${id}/test`;
};

export const testStore = async (
  id: string,
  options?: RequestInit,
): Promise<StoreTestResult> => {
  return customFetch<StoreTestResult>(getTestStoreUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getTestStoreMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testStore>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testStore>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["testStore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testStore>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return testStore(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof testStore>>
>;

export type TestStoreMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Test a store connection
 */
export const useTestStore = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testStore>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testStore>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getTestStoreMutationOptions(options));
};

/**
 * @summary List all automation flows
 */
export const getListFlowsUrl = () => {
  return `/api/flows`;
};

export const listFlows = async (options?: RequestInit): Promise<Flow[]> => {
  return customFetch<Flow[]>(getListFlowsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListFlowsQueryKey = () => {
  return [`/api/flows`] as const;
};

export const getListFlowsQueryOptions = <
  TData = Awaited<ReturnType<typeof listFlows>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listFlows>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFlowsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFlows>>> = ({
    signal,
  }) => listFlows({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFlows>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFlowsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFlows>>
>;
export type ListFlowsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all automation flows
 */

export function useListFlows<
  TData = Awaited<ReturnType<typeof listFlows>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listFlows>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFlowsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new automation flow
 */
export const getCreateFlowUrl = () => {
  return `/api/flows`;
};

export const createFlow = async (
  createFlowRequest: CreateFlowRequest,
  options?: RequestInit,
): Promise<Flow> => {
  return customFetch<Flow>(getCreateFlowUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createFlowRequest),
  });
};

export const getCreateFlowMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFlow>>,
    TError,
    { data: BodyType<CreateFlowRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFlow>>,
  TError,
  { data: BodyType<CreateFlowRequest> },
  TContext
> => {
  const mutationKey = ["createFlow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFlow>>,
    { data: BodyType<CreateFlowRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createFlow(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFlowMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFlow>>
>;
export type CreateFlowMutationBody = BodyType<CreateFlowRequest>;
export type CreateFlowMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a new automation flow
 */
export const useCreateFlow = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFlow>>,
    TError,
    { data: BodyType<CreateFlowRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFlow>>,
  TError,
  { data: BodyType<CreateFlowRequest> },
  TContext
> => {
  return useMutation(getCreateFlowMutationOptions(options));
};

/**
 * @summary Get a flow by ID
 */
export const getGetFlowUrl = (id: string) => {
  return `/api/flows/${id}`;
};

export const getFlow = async (
  id: string,
  options?: RequestInit,
): Promise<Flow> => {
  return customFetch<Flow>(getGetFlowUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetFlowQueryKey = (id: string) => {
  return [`/api/flows/${id}`] as const;
};

export const getGetFlowQueryOptions = <
  TData = Awaited<ReturnType<typeof getFlow>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFlow>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFlowQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFlow>>> = ({
    signal,
  }) => getFlow(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getFlow>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetFlowQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFlow>>
>;
export type GetFlowQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a flow by ID
 */

export function useGetFlow<
  TData = Awaited<ReturnType<typeof getFlow>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFlow>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFlowQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a flow
 */
export const getUpdateFlowUrl = (id: string) => {
  return `/api/flows/${id}`;
};

export const updateFlow = async (
  id: string,
  updateFlowRequest: UpdateFlowRequest,
  options?: RequestInit,
): Promise<Flow> => {
  return customFetch<Flow>(getUpdateFlowUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateFlowRequest),
  });
};

export const getUpdateFlowMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFlow>>,
    TError,
    { id: string; data: BodyType<UpdateFlowRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFlow>>,
  TError,
  { id: string; data: BodyType<UpdateFlowRequest> },
  TContext
> => {
  const mutationKey = ["updateFlow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFlow>>,
    { id: string; data: BodyType<UpdateFlowRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateFlow(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFlowMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFlow>>
>;
export type UpdateFlowMutationBody = BodyType<UpdateFlowRequest>;
export type UpdateFlowMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update a flow
 */
export const useUpdateFlow = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFlow>>,
    TError,
    { id: string; data: BodyType<UpdateFlowRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateFlow>>,
  TError,
  { id: string; data: BodyType<UpdateFlowRequest> },
  TContext
> => {
  return useMutation(getUpdateFlowMutationOptions(options));
};

/**
 * @summary Delete a flow
 */
export const getDeleteFlowUrl = (id: string) => {
  return `/api/flows/${id}`;
};

export const deleteFlow = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteFlowUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteFlowMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFlow>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFlow>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteFlow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFlow>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteFlow(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFlowMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFlow>>
>;

export type DeleteFlowMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a flow
 */
export const useDeleteFlow = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFlow>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteFlow>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteFlowMutationOptions(options));
};

/**
 * @summary Run a flow immediately
 */
export const getRunFlowUrl = (id: string) => {
  return `/api/flows/${id}/run`;
};

export const runFlow = async (
  id: string,
  options?: RequestInit,
): Promise<RunLog> => {
  return customFetch<RunLog>(getRunFlowUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRunFlowMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runFlow>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runFlow>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["runFlow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runFlow>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return runFlow(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunFlowMutationResult = NonNullable<
  Awaited<ReturnType<typeof runFlow>>
>;

export type RunFlowMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Run a flow immediately
 */
export const useRunFlow = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runFlow>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runFlow>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRunFlowMutationOptions(options));
};

/**
 * @summary Get run logs for a specific flow
 */
export const getGetFlowLogsUrl = (id: string, params?: GetFlowLogsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/flows/${id}/logs?${stringifiedParams}`
    : `/api/flows/${id}/logs`;
};

export const getFlowLogs = async (
  id: string,
  params?: GetFlowLogsParams,
  options?: RequestInit,
): Promise<RunLog[]> => {
  return customFetch<RunLog[]>(getGetFlowLogsUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getGetFlowLogsQueryKey = (
  id: string,
  params?: GetFlowLogsParams,
) => {
  return [`/api/flows/${id}/logs`, ...(params ? [params] : [])] as const;
};

export const getGetFlowLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFlowLogs>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  params?: GetFlowLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFlowLogs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFlowLogsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFlowLogs>>> = ({
    signal,
  }) => getFlowLogs(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFlowLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFlowLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFlowLogs>>
>;
export type GetFlowLogsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get run logs for a specific flow
 */

export function useGetFlowLogs<
  TData = Awaited<ReturnType<typeof getFlowLogs>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  params?: GetFlowLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFlowLogs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFlowLogsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get global run logs
 */
export const getListLogsUrl = (params?: ListLogsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/logs?${stringifiedParams}`
    : `/api/logs`;
};

export const listLogs = async (
  params?: ListLogsParams,
  options?: RequestInit,
): Promise<RunLog[]> => {
  return customFetch<RunLog[]>(getListLogsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListLogsQueryKey = (params?: ListLogsParams) => {
  return [`/api/logs`, ...(params ? [params] : [])] as const;
};

export const getListLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLogs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLogs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLogsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLogs>>> = ({
    signal,
  }) => listLogs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLogs>>
>;
export type ListLogsQueryError = ErrorType<unknown>;

/**
 * @summary Get global run logs
 */

export function useListLogs<
  TData = Awaited<ReturnType<typeof listLogs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLogs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLogsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get dashboard stats
 */
export const getGetDashboardUrl = () => {
  return `/api/dashboard`;
};

export const getDashboard = async (
  options?: RequestInit,
): Promise<DashboardStats> => {
  return customFetch<DashboardStats>(getGetDashboardUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardQueryKey = () => {
  return [`/api/dashboard`] as const;
};

export const getGetDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboard>>> = ({
    signal,
  }) => getDashboard({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboard>>
>;
export type GetDashboardQueryError = ErrorType<unknown>;

/**
 * @summary Get dashboard stats
 */

export function useGetDashboard<
  TData = Awaited<ReturnType<typeof getDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
